<template>
  <div class="c-audience">
    <Spin size="large" fix v-if="loading" />
    <Row :gutter="12">
      <Col span="17">
        <Row class-name="m-wrap">
          <Col span="8" class-name="c-group-box m-box">
            <div class="c-header"><span>账号</span></div>
            <div class="c-content">
              <div v-for="account in data" :key="account.id" :class="itemClasses(account)" @click.stop="handleAccount(account)">
                <div class="c-item">
                  <span>{{ account.name }}</span>
                  <Icon type="ios-arrow-forward" class="c-check-arrow" size="14" color="#c1c1c1" />
                </div>
              </div>
            </div>
          </Col>
          <Col span="16" class-name="c-group-box m-box" v-if="len">
            <div class="c-header">
              <span>人群包</span>
              <span class="tag-title tag-icon"
                >排除<Icon
                  v-if="attrSelectAll('exclude')"
                  type="ios-checkbox"
                  color="#2d8cf0"
                  :size="16"
                  @click="changeRetargetAll('excludes', false, current)" />

                <Icon v-else type="ios-square-outline" color="#dcdee2" :size="16" @click="changeRetargetAll('excludes', true, current)"
              /></span>
              <span class="tag-title tag-icon"
                >定向

                <Icon
                  v-if="attrSelectAll('include')"
                  type="ios-checkbox"
                  color="#2d8cf0"
                  :size="16"
                  @click="changeRetargetAll('includes', false, current)" />

                <Icon v-else-if="disCrowd" type="ios-square-outline" color="#bcbcbc" :style="{ cursor: 'not-allowed' }" :size="16" />

                <Icon v-else type="ios-square-outline" color="#dcdee2" :size="16" @click="changeRetargetAll('includes', true, current)"
              /></span>
              <span class="tag-title">属性</span>
              <span class="tag-title">ID</span>
            </div>
            <div class="c-search">
              <Input v-model="keyword" suffix="ios-search" placeholder="请输入关键词" />
            </div>
            <div class="c-content">
              <div class="c-check-item g-clearfix" v-for="item in drops" :key="item.id">
                <span class="m-span">{{ item.name }}</span>
                <span class="item-type">{{ item.id }}</span>
                <span class="item-type">{{ item.type }}</span>
                <RadioGroup v-model="item.select" style="width: 64px; float: right; line-height: 36px">
                  <Radio label="include" :disabled="disCrowd"></Radio>
                  <Radio label="exclude"></Radio>
                </RadioGroup>
                <span v-if="disCrowd" class="m-cataract c-exclude c-disabled"></span>
                <span v-else class="m-cataract c-include" @click.stop="audienceChange(item, current, 'include')"></span>
                <span class="m-cataract c-exclude" @click.stop="audienceChange(item, current, 'exclude')"></span>
              </div>
            </div>
          </Col>
        </Row>
      </Col>
      <Col span="6" offset="1" v-if="Boolean(extend)">
        <div class="m-wrap">
          <div class="m-box c-result-box">
            <span class="c-retarget-clear" @click="handleClear(current)">清空全部</span>
            <Tabs v-model="currenTab" size="small">
              <TabPane class="c-retarget-result" name="include" :label="tabPaneLabel(includes, '定向')">
                <div v-for="item in includes" :key="item.id" class="c-pop-tip">
                  <Tag :name="item.id" class="c-tag-item" closable @on-close="handleClose(item.id, current, 'include')">{{
                    item.name
                  }}</Tag>
                </div>
              </TabPane>
              <TabPane class="c-retarget-result" name="exclude" :label="tabPaneLabel(excludes, '排除')">
                <div v-for="item in excludes" :key="item.id" class="c-pop-tip">
                  <Tag :name="item.id" class="c-tag-item" closable @on-close="handleClose(item.id, current, 'exclude')">{{
                    item.name
                  }}</Tag>
                </div>
              </TabPane>
            </Tabs>
          </div>
        </div>
      </Col>
    </Row>
  </div>
</template>
<script>
import { isArray, trim } from '@/common/js/utils'
import { getAudience } from '@/api/baidu.model'
export default {
  name: 'bdRegarget',
  props: {
    data: {
      type: Array
    },
    media: {
      type: Number
    },
    disCrowd: {
      type: Boolean
    }
  },
  data() {
    return {
      loading: null,
      keyword: '',
      currenTab: 'include',
      current: null
    }
  },
  computed: {
    audience() {
      let audienceData = []
      if (this.current) {
        const account = this.data.filter((ret) => ret.id === this.current).pop()
        audienceData = account.audienceData
      }
      return audienceData
    },
    drops() {
      return this.audience.filter((ret) => {
        const keyword = trim(this.keyword)
        if (keyword) return ret.name.includes(keyword)
        else {
          return true
        }
      })
    },
    itemClasses() {
      return (item) => {
        const cls = ['m-account']
        item.id === this.current && cls.push('active')
        return cls
      }
    },
    len() {
      return isArray(this.audience) && this.audience.length
    },
    includes() {
      const data = []
      const currentData = this.data.filter((ret) => ret.id === this.current).pop()
      if (currentData) {
        const { includes } = currentData
        data.push(...includes)
      }
      return data
    },
    excludes() {
      const data = []
      const currentData = this.data.filter((ret) => ret.id === this.current).pop()
      if (currentData) {
        const { excludes } = currentData
        data.push(...excludes)
      }
      return data
    },
    extend() {
      return this.current && (this.includes.length || this.excludes.length)
    },
    tabPaneLabel() {
      return (val, label) => {
        return `${label}${val.length ? '(' + val.length + ')' : ''}`
      }
    },
    attrSelectAll() {
      return (select) => {
        const bool = isArray(this.audience) && this.audience.length
        if (select === 'exclude') return bool && this.audience.every((ret) => ret.select === 'exclude')
        else if (select === 'include') return bool && this.audience.every((ret) => ret.select === 'include')
      }
    }
  },
  methods: {
    handleClear(account) {
      const index = this.data.findIndex((ret) => ret.id === account)
      this.$set(this.data[index], 'includes', [])
      this.$set(this.data[index], 'excludes', [])
      this.data[index].audienceData.forEach((ret) => {
        this.$set(ret, 'select', false)
      })
    },
    audienceChange(item, account, type) {
      const keys = `${type}s`
      const unkeys = type === 'include' ? 'excludes' : 'includes'
      const index = this.data.findIndex((ret) => ret.id === account)
      const ids = this.data[index][keys].map((ret) => ret.id)
      const idx = this.data[index][unkeys].findIndex((ret) => ret.id === item.id)
      if (idx > -1) this.data[index][unkeys].splice(idx, 1)
      !ids.includes(item.id) && this.data[index][keys].push(item)
      this.$set(item, 'select', type)
    },
    changeRetargetAll(type, check, account) {
      const bool = Boolean(check)
      const unself = type === 'includes' ? 'excludes' : 'includes'
      const index = this.data.findIndex((ret) => ret.id === account)
      const checkList = this.data[index].audienceData
      if (isArray(checkList)) {
        checkList.forEach((ret) => {
          this.$set(ret, 'select', bool ? type.substr(0, type.length - 1) : null)
          if (bool) {
            const idx = this.data[index][unself].findIndex((met) => met.id === ret.id)
            const sdx = this.data[index][type].findIndex((met) => met.id === ret.id)
            if (idx > -1) this.data[index][unself].splice(idx, 1)
            sdx < 0 && this.data[index][type].push(ret)
          } else {
            const idx = this.data[index][type].findIndex((met) => met.id === ret.id)
            if (idx > -1) this.data[index][type].splice(idx, 1)
          }
        })
      }
    },
    handleClose(item, account, type) {
      const keys = `${type}s`
      const index = this.data.findIndex((ret) => ret.id === account)
      const idx = this.data[index][keys].findIndex((ret) => ret.id === item)
      const audx = this.data[index].audienceData.findIndex((ret) => ret.id === item)
      const audience = this.data[index].audienceData[audx]
      if (idx > -1) this.data[index][keys].splice(idx, 1)
      this.$set(audience, 'select', false)
    },
    handleAccount({ id, xhr }) {
      this.current = id
      !xhr && this.getAccountAudience(id)
    },
    getAccountAudience(id) {
      const index = this.data.findIndex((ret) => ret.id === this.current)
      this.loading = true
      getAudience({
        ad_account_id: id
      }).then((data) => {
        if (typeof data !== 'symbol') this.loading = false
        if (isArray(data)) {
          const audienceData = data
            .filter((ret) => ret.groupStatus === 'finished')
            .map((ret) => {
              return {
                id: ret.groupId,
                name: ret.groupName,
                type: ret.groupTypeDesc
              }
            })
          if (index > -1) {
            this.$set(this.data[index], 'audienceData', audienceData)
            this.$set(this.data[index], 'xhr', true)
          }
        }
      })
    },
    selectCurrent() {
      this.current = this.data[0].id
    }
  }
}
</script>
<style lang="scss" scoped>
.c-audience {
  position: relative;

  .m-wrap {
    border-bottom: 1px solid #e8eaec;
    border-right: 1px solid #e8eaec;
  }

  .m-box {
    border-top: 1px solid #e8eaec;
    border-left: 1px solid #e8eaec;
  }

  .c-group-box {
    position: relative;
    background-color: #fff;
    min-height: 332px;

    .c-header {
      padding: 0 8px;
      height: 34px;
      font-size: 14px;
      color: #333;
      border-bottom: 1px solid #e8eaec;
      background-color: #f8f8f8;
      position: relative;

      span {
        line-height: 34px;
        vertical-align: middle;
      }

      span.tag-title {
        float: right;
        font-size: 12px;
        margin-right: 14px;
      }

      span.tag-icon {
        margin-right: 0;

        .ivu-icon {
          cursor: pointer;
        }
      }
    }

    .c-search {
      padding: 6px 8px;
    }

    .c-content {
      overflow-y: auto;
      scrollbar-width: thin;
      -webkit-overflow-scrolling: touch;
      height: 253px;
      width: 100%;
      padding-bottom: 8px;

      .m-account {
        padding: 8px 8px;
        display: flex;

        &:hover {
          background-color: #f8f8f8;
        }

        &.active {
          color: #598fe6;
          background-color: #f8f8f8;

          .c-check-arrow {
            color: #598fe6 !important;
          }
        }
      }

      .c-item {
        width: 100%;
        position: relative;
        z-index: 5;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        span {
          width: calc(100% - 18px);
          line-height: 20px;
        }
      }

      .c-check-item {
        margin: 0;
        padding-left: 8px;
        display: flex;
        position: relative;
        align-items: center;
        height: 36px;
        width: 100%;

        &:hover {
          background-color: #f8f8f8;
        }

        .m-span {
          width: calc(100% - 186px);
          display: inline-block;
        }

        .item-type {
          text-align: right;
          display: inline-block;
          width: 60px;
          padding-right: 10px;
        }

        .ivu-radio-group {
          width: 70px !important;
        }

        .ivu-radio-wrapper {
          min-width: inherit;
          text-align: right;
          font-size: 0;
          margin-right: 14px;
        }

        .m-cataract {
          position: absolute;
          width: 18px;
          height: 36px;
          cursor: pointer;
          user-select: none;
          top: 0;
          z-index: 2;

          &.c-disabled {
            cursor: not-allowed;
          }
        }

        .c-include {
          right: 50px;
        }

        .c-exclude {
          right: 18px;
        }
      }
    }
  }

  .c-result-box {
    position: relative;

    ::v-deep .ivu-tabs-bar {
      background-color: #f8f8f8;
    }

    .c-retarget-clear {
      width: 60px;
      height: 34px;
      line-height: 34px;
      position: absolute;
      z-index: 8;
      right: 0;
      top: 0;
      display: block;
      color: #598fe6;
      text-align: center;
      cursor: pointer;
    }

    .c-retarget-result {
      overflow-y: auto;
      scrollbar-width: thin;
      -webkit-overflow-scrolling: touch;
      height: 294px;
      padding-bottom: 8px;
      background-color: #fff;

      .c-tag-item {
        margin: 8px 12px 0;
        padding: 2px 6px;
        display: block;
        height: 28px;
      }
    }
  }
}
</style>
